(function() {
  'use strict';
  
  angular
    .module('plugins.q-and-a')
    .controller('QAndAResultHiddenController', QAndAResultHiddenController);
  
  QAndAResultHiddenController.$inject = [
    '$log', 
    '$scope',
    'pollPluginService'
  ];
    
  function QAndAResultHiddenController(
      $log, 
      $scope,
      pollPluginService
    ) {
    $log = $log.getInstance('QAndAResultHiddenController');
    
    /* jshint validthis: true */
    var vm = this;
    
    vm.numberOfQuestions = 0

    activate();

    function activate() {
      var result = $scope.result;
      
      // Run through previous responses
      result.responses.forEach(function(response) { 
        if (response.data.question) vm.numberOfQuestions++
      })

      pollPluginService.onResponseReceived($scope, result._id, _onResponseReceived);
    }
    
    function _onResponseReceived(response) {
      $scope.result.responses.push(response)
      if (response.data.question) vm.numberOfQuestions++
    }
    
  }
  
})();